import jQuery from "jquery";
(function (far, $) {
  far.lazyContent = {};

  var _queuedContent = new Array();
  var _initialLazyLoadingDelay = 200;

  //#region Public functions ====================================================

  far.lazyContent.initialize = function () {
    queueLazyLoadingContent();
  };

  $(document).on("click", ".coursedocument", function (event) {
    event.preventDefault();
    var $this = $(this);
    var id = $this.attr("data-id");
    var name = $this.attr("data-filename");
    var action = $this.attr("data-action");
    var  url = "/courses/" + action + "/?id=" + id + "&fileName=" + name;
    document.location = url;
  });

  //#endregion

  //#region Private functions ===================================================

  function queueLazyLoadingContent() {
    $(".js-ajaxloader").each(function () {
      var element = $(this);
      element.addClass("js-loading");
      _queuedContent.push({
        target: element,
        url: element.attr("data-url"),
        oncomplete: element.attr("data-oncomplete"),
      });
    });

    _queuedContent = _queuedContent.reverse(); // bottom-up order

    setTimeout(loadQueuedContent, _initialLazyLoadingDelay);
  }

  function loadQueuedContent() {
    if (_queuedContent.length === 0) {
      return;
    }

    var item = _queuedContent.pop();
    $.get(item.url)
      .done(function (data) {
        item.target.removeClass("js-loading").html(data);
        if (typeof item.oncomplete !== "undefined") {
          eval(item.oncomplete);
        }
      })
      .fail(function (error) {
        console.log(error);
      })
      .always(function () {
        loadQueuedContent();
      });
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
